<template>
  <div class="results-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Resultados Comprovados</span>
        <h2>Projetos que transformaram negócios</h2>
        <p>Veja como ajudamos empresas a crescer com nossas soluções digitais</p>
      </div>

      <div class="results-grid">
        <!-- Result Card 1 -->
        <div class="result-card" data-aos="fade-up">
          <div class="result-icon">
            <i class="ph-storefront"></i>
          </div>
          <div class="result-content">
            <h3>E-commerce de Moda</h3>
            <p class="result-description">
              Desenvolvimento completo de plataforma de e-commerce com integrações de pagamento e sistema de fidelidade.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">350%</span>
                <span class="label">Aumento em vendas</span>
              </div>
              <div class="stat">
                <span class="number">5mil+</span>
                <span class="label">Usuários ativos</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">E-commerce</span>
              <span class="tag">React</span>
              <span class="tag">Node.js</span>
            </div>
          </div>
        </div>

        <!-- Result Card 2 -->
        <div class="result-card" data-aos="fade-up" data-aos-delay="100">
          <div class="result-icon">
            <i class="ph-heartbeat"></i>
          </div>
          <div class="result-content">
            <h3>Sistema para Clínica Médica</h3>
            <p class="result-description">
              Plataforma completa de gestão com agendamentos online, prontuários eletrônicos e telemedicina integrada.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">80%</span>
                <span class="label">Redução em faltas</span>
              </div>
              <div class="stat">
                <span class="number">2x</span>
                <span class="label">Mais produtividade</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">Saúde</span>
              <span class="tag">Vue.js</span>
              <span class="tag">Laravel</span>
            </div>
          </div>
        </div>

        <!-- Result Card 3 -->
        <div class="result-card" data-aos="fade-up" data-aos-delay="200">
          <div class="result-icon">
            <i class="ph-truck"></i>
          </div>
          <div class="result-content">
            <h3>App de Logística</h3>
            <p class="result-description">
              Aplicativo mobile para gestão de entregas com rastreamento em tempo real e otimização de rotas.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">40%</span>
                <span class="label">Economia em combustível</span>
              </div>
              <div class="stat">
                <span class="number">1.2k</span>
                <span class="label">Entregas/dia</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">Mobile</span>
              <span class="tag">Flutter</span>
              <span class="tag">Firebase</span>
            </div>
          </div>
        </div>

        <!-- Result Card 4 -->
        <div class="result-card" data-aos="fade-up" data-aos-delay="300">
          <div class="result-icon">
            <i class="ph-chalkboard-teacher"></i>
          </div>
          <div class="result-content">
            <h3>Plataforma de Ensino Online</h3>
            <p class="result-description">
              Sistema completo de EAD com videoaulas, exercícios interativos, gamificação e certificados digitais.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">10k+</span>
                <span class="label">Alunos cadastrados</span>
              </div>
              <div class="stat">
                <span class="number">95%</span>
                <span class="label">Satisfação</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">Educação</span>
              <span class="tag">Next.js</span>
              <span class="tag">AWS</span>
            </div>
          </div>
        </div>

        <!-- Result Card 5 -->
        <div class="result-card" data-aos="fade-up" data-aos-delay="400">
          <div class="result-icon">
            <i class="ph-chart-line-up"></i>
          </div>
          <div class="result-content">
            <h3>CRM Personalizado</h3>
            <p class="result-description">
              Sistema de gestão de relacionamento com clientes, automação de marketing e análise de dados em tempo real.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">60%</span>
                <span class="label">Mais conversões</span>
              </div>
              <div class="stat">
                <span class="number">3x</span>
                <span class="label">ROI em vendas</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">CRM</span>
              <span class="tag">Python</span>
              <span class="tag">PostgreSQL</span>
            </div>
          </div>
        </div>

        <!-- Result Card 6 -->
        <div class="result-card" data-aos="fade-up" data-aos-delay="500">
          <div class="result-icon">
            <i class="ph-fork-knife"></i>
          </div>
          <div class="result-content">
            <h3>App de Delivery</h3>
            <p class="result-description">
              Aplicativo completo de delivery para restaurantes com pedidos online, pagamentos integrados e programa de fidelidade.
            </p>
            <div class="result-stats">
              <div class="stat">
                <span class="number">500+</span>
                <span class="label">Pedidos/dia</span>
              </div>
              <div class="stat">
                <span class="number">4.8★</span>
                <span class="label">Avaliação</span>
              </div>
            </div>
            <div class="result-tags">
              <span class="tag">Food Tech</span>
              <span class="tag">React Native</span>
              <span class="tag">MongoDB</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cta-section text-center" data-aos="fade-up">
        <h3>Pronto para transformar seu negócio?</h3>
        <p>Entre em contato e veja como podemos ajudar sua empresa a crescer</p>
        <a href="https://wa.me/5554992302401?text=Quero um projeto de sucesso como esses!"
           target="_blank"
           class="btn-style-one green-color"
           rel="noopener noreferrer">
          <i class="flaticon-whatsapp"></i>
          Falar com Especialista
          <i class="ph-caret-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Results'
}
</script>

<style scoped>
.results-area {
  background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.result-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.result-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #6D5DFC 0%, #4361EE 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.result-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

.result-card:hover::before {
  transform: scaleX(1);
}

.result-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.1) 0%, rgba(67, 97, 238, 0.1) 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.result-icon i {
  font-size: 36px;
  color: #6D5DFC;
}

.result-content h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.result-description {
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
  min-height: 80px;
}

.result-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 12px;
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat .number {
  font-size: 28px;
  font-weight: 700;
  color: #6D5DFC;
}

.stat .label {
  font-size: 13px;
  color: #666;
}

.result-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 6px 12px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.2);
  border-radius: 20px;
  font-size: 12px;
  color: #6D5DFC;
  font-weight: 600;
}

.cta-section {
  margin-top: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 20px;
  color: white;
}

.cta-section h3 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  color: white;
}

.cta-section p {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.95;
  color: white;
}

.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: none;
  padding: 15px 35px;
  font-size: 16px;
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
}

@media (max-width: 768px) {
  .results-grid {
    grid-template-columns: 1fr;
  }

  .result-stats {
    grid-template-columns: 1fr;
  }

  .cta-section {
    padding: 40px 20px;
  }

  .cta-section h3 {
    font-size: 24px;
  }
}
</style>